import React from "react";

import Input from "@material-ui/core/Input";

class Search extends React.Component {
  onChange(value) {
    const onSearchChange = this.props.onSearchChange || null;
    if (onSearchChange) {
      onSearchChange(value);
    }
  }

  render() {
    const { searchText, hasSearch } = this.props;

    if (hasSearch) {
      return (
        <div className="search">
          <Input
            defaultValue={searchText}
            margin="dense"
            type="search"
            placeholder="Search this table"
            onChange={(e) => this.onChange(e.target.value)}
            disableUnderline={true}
          />
        </div>
      );
    }

    return null;
  }
}

export default Search;
